export const ontimeTooltip = {
  _light: {
    backgroundColor: '#2d2d2d', // $gray-1100
    color: '#ececec', // $gray-100
    padding: '2px 8px',
  },
  _dark: {
    backgroundColor: '#2d2d2d', // $gray-1100
    color: '#ececec', // $gray-100
    padding: '2px 8px',
  },
};
